import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CdkPortalOutlet, Portal } from '@angular/cdk/portal';

import { NX_MODAL_DATA, NxModalRef } from '@allianz/ng-aquila/modal';

import {
  ConfirmationModalAcceptButtonConfig,
  ConfirmationModalCancelButtonConfig,
  ConfirmationModalConfig,
} from './confirmation-modal.model';
import { NxCopytextComponent } from '@allianz/ng-aquila/copytext';
import {
  ModalLayoutComponent,
  ModalLayoutConfig,
  ModalType,
} from '@retail-portal-santander-frontend/remote-shared-ui-modal-layout';
import { ButtonGroup } from '@retail-portal-santander-frontend/remote-shared-ui-button-group';

@Component({
  standalone: true,
  selector: 'allianz-confirmation-modal',
  templateUrl: 'confirmation-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NxCopytextComponent, ModalLayoutComponent, CdkPortalOutlet],
})
export class ConfirmationModalComponent {
  readonly data = inject<ConfirmationModalConfig>(NX_MODAL_DATA);
  private modalRef = inject<NxModalRef<ConfirmationModalComponent, boolean>>(NxModalRef);

  message: string = this.data.message;
  additionalMessage: string = this.data.additionalMessage;
  acceptButton: ConfirmationModalAcceptButtonConfig = this.data.acceptButton;
  cancelButton: ConfirmationModalCancelButtonConfig = this.getCancelButtonConfig(this.data.cancelButton);
  customComponent: Portal<unknown> = this.data.customComponent;
  modalConfig: ModalLayoutConfig = {
    type: ModalType.STATUS,
    title: this.data.header,
    status: this.data.status,
  };

  actionButtons: ButtonGroup = [
    {
      label: this.cancelButton.label,
      nxButtonType: `${this.cancelButton.type} small`,
      testId: 'confirmation-modal/cancel',
      action: (): void => this.close(false),
    },
    {
      label: this.acceptButton.label,
      nxButtonType: `${this.acceptButton.type} small`,
      testId: 'confirmation-modal/accept',
      action: (): void => this.close(true),
    },
  ];

  close(result: boolean): void {
    this.modalRef.close(result);
  }

  private getCancelButtonConfig(
    cancelButton: ConfirmationModalCancelButtonConfig
  ): ConfirmationModalCancelButtonConfig {
    const defaultButton: ConfirmationModalCancelButtonConfig = {
      label: `Cancel`,
      type: 'secondary',
    };

    if (!cancelButton) {
      return defaultButton;
    }

    return {
      label: cancelButton.label || defaultButton.label,
      type: cancelButton.type || defaultButton.type,
    };
  }
}
